import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import { AIAgentProvider } from "@/contexts/AIAgentContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CurrencyProvider>
        <AIAgentProvider>
          <App />
        </AIAgentProvider>
      </CurrencyProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
